import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./state-chip.style";
import checkIcon from "@iconify/icons-mdi/check";
import checkBoldIcon from "@iconify/icons-mdi/check-bold";
import closeIcon from "@iconify/icons-mdi/close";
import exclamationIcon from "@iconify/icons-mdi/exclamation";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcStateChipProps {
  label: string;
  state:
    | "requested"
    | "approved"
    | "rejected"
    | "recorded"
    | "assigned"
    | "cancelled";
  loading: boolean;
  variant: "body1" | "body2" | "caption" | "h6"; // Adjust as per your Typography variants
  tooltip?: boolean;
}

export const OcStateChip: React.FC<OcStateChipProps> = ({
  label,
  state,
  loading,
  variant,
  tooltip,
}) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getColor = (
    state:
      | "requested"
      | "approved"
      | "rejected"
      | "recorded"
      | "assigned"
      | "cancelled",
  ) => {
    switch (state) {
      case "requested":
        return theme.palette.yellowBase.main;
      case "approved":
        return theme.palette.greenBase.main;
      case "rejected":
        return theme.palette.primary.main;
      case "recorded":
        return theme.palette.greenBase.main;
      case "assigned":
        return theme.palette.blueBase.main;
      case "cancelled":
        return theme.palette.primary.main;
      default:
        return theme.palette.white.main;
    }
  };

  const iconMap = {
    requested: exclamationIcon,
    rejected: closeIcon,
    recorded: checkBoldIcon,
    approved: checkIcon,
    assigned: checkBoldIcon,
    cancelled: closeIcon, // Add an appropriate icon for "cancellation"
  };

  const iconColor = getColor(state);
  const IconComponent = iconMap[state];
  const classes = useStyles({ borderColor: iconColor, isMobile });

  return (
    <div className={classes.root}>
      {isMobile && IconComponent && (
        <InlineIcon
          icon={IconComponent}
          className={classes.text}
          width="24px"
          style={{
            color: iconColor,
            cursor: "pointer",
          }}
        />
      )}
      {!isMobile && (
        <Typography
          className={loading ? classes.textLoading : classes.text}
          variant={variant}
          color={
            tooltip ? theme.palette.white.main : theme.palette.darkBase.main
          }
        >
          {label}
        </Typography>
      )}
    </div>
  );
};

export default OcStateChip;
